module.exports = __webpack_public_path__ + "static/intervally-app-icon-818ab464c4532a225a35dfa03185aaba.png";